import Dexie, { Table } from 'dexie';
import { DataPointTreeItem } from 'src/pages/SignInPage/_BLL/types';

export class MySubClassedDexie extends Dexie {
	dataPointTreeBoolean!: Table<DataPointTreeItem>;

	constructor() {
		super('dataPointTreeBoolean');
		this.version(1).stores({
			dataPointTreeBoolean: '++key',
		});
	}
}

export const db = new MySubClassedDexie();
